module.exports = __webpack_public_path__ + "static/media/Rear Left Tire.6d69fa4e.svg";